<template>
  <div
    class="header h-[100px] desktop:h-auto w-full p-5 desktop:pt-2.5 desktop:pr-0 desktop:pb-8 desktop:pl-0 fixed desktop:relative top-0 left-0 z-[3] flex flex-col items-center justify-end bg-white desktop:bg-transparent transition-all duration-300 ease-in-out"
  >
    <Banner v-if="enableUpgrade && baseRoute != 'clientSettings'" />
    <slot />
    <HeaderMobile class="header__inner--mobile" />
  </div>
</template>
<script setup>
import Banner from '@/components/banner/Banner'
import HeaderMobile from '@/components/header/HeaderMobile'
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const baseRoute = computed(() => store.state.navigation.baseRoute)
const enableUpgrade = computed(() => store.getters['account/enableUpgrade'])
</script>
<style lang="scss">
.header__inner {
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr 1fr;
  .header__breadcrumbs {
    grid-row: 2 / -1;
    &::-webkit-scrollbar {
      display: none !important; /* Chrome Safari */
    }
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
  }
}

@include mobileLandscape {
  .header__inner {
    grid-template-rows: 1fr;
    .header__breadcrumbs {
      grid-row: 1 / -1;
    }
  }
}

@include desktop {
  .header__inner {
    grid-template-columns: 1fr auto auto auto auto;
    &--list {
      grid-template-columns: 1fr auto auto auto auto auto;
    }
  }
}
</style>
